/**
 * RulesIcon — An arrow off a starting line: a rule that acts when its condition holds. Hugeicons
 * arrow-big-right-dash (MIT).
 */

import svg from './svg/rules.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const RulesIcon = makeSvgIcon('rules', svg);
